module.exports = __webpack_public_path__ + "img/no-contact.d0eacfdf.svg";